export const CREATE_PLAN_TOUR = {
  id: "create_plan",
  steps: [
    {
      element: '[data-tour="plan-name"]',
      popover: {
        title: "Nome do plano",
        description:
          'Escolha um nome claro como "Starter", "Pro" ou "Enterprise".',
        side: "bottom",
      },
    },
    {
      element: '[data-tour="plan-pricing"]',
      popover: {
        title: "Modelo de precificação",
        description:
          'Escolha "Flat" para um valor fixo, ou "Por unidade"/"Por volume" para cobrar com base em licenças ou créditos consumidos.',
        side: "bottom",
      },
    },
    {
      element: '[data-tour="plan-licenses"]',
      popover: {
        title: "Licenças incluídas",
        description:
          "Defina quantas licenças de cada tipo o plano inclui por padrão. Use 0 para ilimitado.",
        side: "top",
      },
    },
    {
      element: '[data-tour="plan-credits"]',
      popover: {
        title: "Créditos",
        description:
          'Defina quantos créditos o plano inclui por ciclo. Marque "Permitir compra de extras" para que o cliente possa comprar mais.',
        side: "top",
      },
    },
    {
      element: '[data-tour="plan-features"]',
      popover: {
        title: "Features",
        description:
          "Ative as features inclusas neste plano. Features são enviadas nos webhooks para o seu sistema.",
        side: "top",
      },
    },
  ],
};
